module.exports = __webpack_public_path__ + "img/Weekdays.27b06fbf.svg";